import { render, staticRenderFns } from "./InventarioSimPantalla.vue?vue&type=template&id=69faa9ac&"
import script from "./InventarioSimPantalla.vue?vue&type=script&lang=ts&"
export * from "./InventarioSimPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports